import {ExerciseWorkoutProps} from '../../types';
import {ExercisePreviewData} from './ExercisePreview.type';

export class ExercisePreviewService {
  static formatExerciseData(
    workoutExercise: ExerciseWorkoutProps,
  ): ExercisePreviewData {
    const exercise = workoutExercise.exercise;

    return {
      name: exercise?.label || exercise?.name || 'Exercício sem nome',
      imageUrl: this.getImageUrl(exercise),
      details: {
        series: workoutExercise.series || workoutExercise.rounds,
        reps: workoutExercise.reps || workoutExercise.repetitions,
        weight: workoutExercise.weight || workoutExercise.load,
        time: workoutExercise.time || workoutExercise.timeText,
        restTime: workoutExercise.restTime,
        notes: workoutExercise.notes,
      },
    };
  }

  static getImageUrl(exercise: any): string | undefined {
    if (!exercise) return undefined;

    if (exercise.animatedImage?.uriOriginal) {
      return exercise.animatedImage.uriOriginal;
    }
    if (exercise.animatedImage?.uri) {
      return exercise.animatedImage.uri;
    }
    if (exercise.image?.uri) {
      return exercise.image.uri;
    }
    if (exercise.image?.uriOriginal) {
      return exercise.image.uriOriginal;
    }
    return undefined;
  }

  static formatDetailText(label: string, value?: string): string | null {
    if (!value || value.trim() === '') return null;
    return `${label}: ${value}`;
  }

  static hasAnyDetails(details: ExercisePreviewData['details']): boolean {
    return Object.values(details).some((value) => value && value.trim() !== '');
  }
}
